import "./BookingCalendar.scss"
import moment, {Moment} from "moment";
import React, {Fragment, useEffect, useState} from "react";
import {$clientApi} from "../../../../http";
import Spinner from "../../../../components/Spiner/Spinner";
import {IClassEventReservation} from "../../../../models/ClassEventReservation";
import ReservationDescription from "./ReservationDescription/ReservationDescription";
import ReservationCircles from "./ReservationCircles/ReservationCircles";
import ReservationsPopup from "./ReservationsPopup/ReservationsPopup";
import BookingCalendarPopup from "../BookingCalendarPopup/BookingCalendarPopup";


interface IBookingCalendarProps {
    startDay: Moment
}

const BookingCalendar: React.FC<IBookingCalendarProps> = ({startDay}) => {

    const day = startDay.clone();
    const daysArray = [...Array(42)].map(() => day.add(1, "day").clone());
    const from = daysArray[0].clone();
    const to = daysArray[daysArray.length - 1].clone().add(1, "day");
    const daysOfTheWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const [showDescriptionReservation, setShowDescriptionReservation] = useState<{
        isOpen: boolean,
        reservation: IClassEventReservation | null
    }>({isOpen: false, reservation: null})

    const [daysArrayWithEvent, setDaysArrayWithEvents] = useState<{
        date: string,
        reservations: IClassEventReservation[]
    }[]>(daysArray.map(el => ({date: el.toISOString(), reservations: []})));
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        getEvents();
    }, [startDay]);

    const getEvents = async () => {
        const dateArray = daysArray.map(el => ({date: el.toISOString(), reservations: []}))
        setShowLoader(true);
        const response = await $clientApi.get<IClassEventReservation[]>(`api/class-events/reservation-for-customer?start=${from.toISOString()}&end=${to.toISOString()}&calendarView=month`);
        const newArray = dateArray.map(el => {
            const reservations = response.data.filter(event => moment(event.occuranceDate).isSame(moment(el.date), "day"))
                .sort((a, b) => {
                    const dateA = moment(a.occuranceDate);
                    const dateB = moment(b.occuranceDate);
                    if (dateA.isBefore(dateB)) {
                        return -1;
                    } else if (dateA.isAfter(dateB)) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            return {
                date: el.date,
                reservations
            }
        })
        setDaysArrayWithEvents(newArray);
        setShowLoader(false);
    }

    if (showLoader) {
        return (
            <div className="loader-wrapper">
                <Spinner/>
            </div>
        )
    }

    return (
        <>
            <div className="calendar-grid-wrapper">

                <ul className="list-header">
                    {
                        daysOfTheWeek.map(el => {
                            return (
                                <li className="list-header__item" key={el}>
                                    {el}
                                </li>
                            )
                        })
                    }
                </ul>


                <ul className="list">
                    {
                        daysArrayWithEvent && daysArrayWithEvent.map((el, index) => {
                            return (
                                <React.Fragment key={moment(el.date).toISOString()}>
                                    <li
                                        className={`item custom-scroll ${moment().isSame(el.date, "day") ? "current" : ""}`}>
                                        <div className="item-header">
                                            {
                                                index < 7 ? <span className="item-day">
                                                {moment(el.date).format("dddd")}
                                            </span> : <span></span>
                                            }
                                            <p className="item-cell">{moment(el.date).format("DD")}</p>
                                        </div>
                                        <ul className="reservations-list">
                                            {el.reservations.length ? el.reservations.map(reservation => {
                                                return <ReservationDescription key={reservation.id} setShowDescriptionReservation={setShowDescriptionReservation} reservation={reservation}/>
                                            }) : ""}
                                        </ul>
                                    </li>

                                    <li
                                        className={`item-adaptive  ${moment().isSame(el.date, "day") ? "current" : ""}`}>
                                        <p className="date">{moment(el.date).format("DD")}</p>
                                        <ReservationCircles reservation={el.reservations}/>
                                        {el.reservations.length ? <ReservationsPopup isCurrent={moment().isSame(el.date, "day")} setShowDescriptionReservation={setShowDescriptionReservation} reservations={el.reservations}/> : ""}
                                    </li>

                                </React.Fragment>
                            )
                        })
                    }
                </ul>
            </div>
            {
                (showDescriptionReservation.isOpen && showDescriptionReservation.reservation) &&
                <BookingCalendarPopup
                    setShowDescriptionReservation={setShowDescriptionReservation}
                    reservation={showDescriptionReservation.reservation}
                    getClassEvents={getEvents}
                />
            }
        </>
    )
}

export default BookingCalendar;